<video *ngIf="autoPlay" preload="metadata" [ngStyle]="{'width': width, 'max-height': maxHeight}" (click)="pauseOrPlay()" loop playsinline webkit-playsinline muted="muted" #videoPlayer autoplay>
  <source [src]="videoScrValue(videoSrc)" type="{{sourceType}}">
</video>
<video *ngIf="!autoPlay" preload="metadata" [ngStyle]="{'width': width, 'max-height': maxHeight}" (click)="pauseOrPlay()" loop playsinline webkit-playsinline muted="muted" #videoPlayer>
  <source [src]="videoScrValue(videoSrc)" type="{{sourceType}}">
</video>